import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const setAuthToken = (token) => {
    if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        localStorage.setItem("cf_admin_token", token);
    } else {
        delete api.defaults.headers.common["Authorization"];
        localStorage.removeItem("cf_admin_token");
    }
};

const stored = typeof window !== "undefined" ? localStorage.getItem("cf_admin_token") : null;
if (stored) {
    api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}
